import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.css']
})
export class FooterMenuComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  contacts() {
    this.router.navigateByUrl('contacts');
  }

  privacyPolicy() {
    this.router.navigateByUrl('/privacy-policy');
  }

  termsOfService() {
    this.router.navigateByUrl('/terms-of-service');
  }
}